// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ca44272f","453":"9565eb5e","455":"07834847","806":"6c7fc78f","977":"965150cb"}[chunkId] + ".chunk.js";
};